module.exports = __webpack_public_path__ + "img/wifi.04692f51.svg";